export default __webpack_public_path__ + "static/media/appstore.7a5ea8b4.png";